module.exports = __webpack_public_path__ + "static/media/lobby-bg-mobile.5b8772ac.jpg";